export const userConstants = {
    USER_LOGIN: 'user/login',
    USER_LOGOUT: 'user/logout',
    USER_REFRESH: 'user/refresh',
    USER_LOGGING: 'user/logging',
    USER_CURRENT: 'user/current',
    TWO_FACTOR_CODE: 'user/two_factor_code',
};